'use strict'

const storeID = 1
const appVersion = 1.1





// function _appVersion(){
// 	return appVersion;
// }

// function _storeid(){
// 	return storeID;
// }



module.exports = {
  appversion: appVersion,
  storeID: storeID
}


//////////////////
// WEBPACK FOOTER
// ./config/appsetting.js
// module id = 9F4c
// module chunks = 49